export enum DatiqUserPermissions {
    EnableRateForecastFiftyTwoWeeks = 'Enable Rate Forecast-52 weeks',
    EnableMarketConditionsForecast = 'Enable Market Conditions Forecast',
    NationalAccount = 'National Account',
    KeyAccount = 'Key Account',
    EnableMarketConditionsGauge = 'Enable Market Conditions Gauge',
    HotMarketMapsEnable = 'Hot Market Maps Enable',
    ContractRateHistoricLookup = 'Contract Rate Historic Lookup',
    ClientEnableFreightMatching = 'Client Enable Freight Matching',
    RfpToolEnabled = 'Rfp Tool Enabled',
    SpotRateBestExpansionPA15 = 'Spot Rate Best Expansion PA 15',
    SpotRateBestExpansionPA7 = 'Spot Rate Best Expansion PA 7',
    SpotRateBestExpansionPA3 = 'Spot Rate Best Expansion PA 3',
    RateLookupApi = 'ENABLE_RATE_LOOKUP_API',
    BenchmarkAnalyticsCapability = 'Benchmark IQ Shipper',
    InternalAccount = 'Internal Account'
}

export enum DatiqUserTiers {
    TierOne = 'Tier 1',
    TierTwo = 'Tier 2',
    TierThree = 'Tier 3',
    NoTier = 'no tier',
    Unknown = '',
}
